import React, { memo } from 'react';
import { Text } from '@Sage/hoi-poi-ui';

const TitleContentDetail = memo(({ label }) => {
    if (!label) return null;
    return <Text type="h6">{label}</Text>;
});

export default TitleContentDetail;
